<div class="workspace-selection slide-container" [ngClass]="classes()!">
	<div class="tabs" role="tablist">
		@for (tab of tabs; track tab) {
			<a class="tab" role="tab" [class.is-active]="activeTab && activeTab === tab" (click)="openTab(tab)">
				<div class="text-and-border">
					<span class="h5" [translate]="'navigation.workspace.tab.' + tab"></span>
					<span class="tab-border"></span>
				</div>
			</a>
		}
	</div>

	<nav>
		<div class="filter">
			<input
				#searchInput
				type="text"
				class="text"
				[(ngModel)]="inputSearchTerm"
				[attr.placeholder]="'navigation.workspace.filter.placeholder' | translate"
			/>
		</div>

		<stages-carousel #carousel>
			@for (tab of tabs; track tab) {
				<stages-carousel-item [name]="tab">
					<ng-template>
						@if (tab !== "navigate") {
							<stages-workspace-list
								[workspaces]="(workspaces$ | async)!"
								[preSelected]="currentWorkspaceId"
								[filterTerm]="searchTerm"
								[enableLocalFilter]="
									tab === 'favorites' || tab === 'archived' || tab === 'related' || tab === 'modules'
								"
								[bookmarkable]="bookmarkable()"
								[showEmpty]="tab !== 'search'"
								[searchEngineAvailable]="tab !== 'search' || searchEngineAvailable"
								(selected)="onSelectWorkspace($event)"
								(bookmark)="onBookmark($event)"
								stagesClickStopPropagation
							>
							</stages-workspace-list>
						}
						@if (tab === "navigate") {
							<stages-workspace-carousel
								[folder]="(folder$ | async)!"
								[preSelected]="currentWorkspaceId"
								[filterTerm]="searchTerm"
								(up)="onNavigate($event)"
								(down)="onNavigate($event)"
								(selected)="onSelectWorkspace($event)"
								stagesClickStopPropagation
							>
							</stages-workspace-carousel>
						}
					</ng-template>
				</stages-carousel-item>
			}
		</stages-carousel>
	</nav>
</div>
